import * as types from 'store/modules/hres6oe/mutation-types'
import checkin from 'api/hres6oe'
import swal from 'sweetalert'
import hres6oeLabels from 'assets/labels/hres6oe'
import { hres6oeColumns } from 'assets/columns/hres6oe'
// import assetsLabels from 'assets/js/labels'
// import axios from 'axios'
import { constLabels } from 'assets/js/constLabels.js'
import configLabel from 'src/../config/label'
// import moment from 'moment' // for demo

export default {
  state: {
    placeDisp: true,
    historyDisp: false,
    hisDetailDisp: false,
    detailDisp: false,
    labels: hres6oeLabels,
    columns: hres6oeColumns(),
    historySelected: {},
    place: [],
    placeAll: [],
    placeNewLatLng: {
      total: 0,
      rows: []
    },
    history: [
      {
        'month': '0',
        'year': '',
        'days': [
          {
            'day': '',
            'dayweek': '',
            'details': []
          }
        ]
      }
    ],
    detail: {},
    detailDemo: {},
    dropdowns: {
      codreason: {
        th: {},
        en: {}
      }
    },
    dataInRadius: [],
    lastCheckIn: {
      'coderror': ' ',
      'desc_coderror': ' ',
      'item_error': ' ',
      'flg': ' ',
      'total': '1',
      'flgcanedit': '1',
      'rcnt': 'Y',
      'dtework': '07/12/2017',
      'seqno': '1',
      'dtein': '',
      'timin': '',
      'dteout': '',
      'timout': '',
      'codcust': '999',
      'typplace': '',
      'namcust': '',
      'codjob': 'UNDEFINED',
      'codreason': '0001',
      'namreason': 'On Site Service',
      'activity': 'test',
      'new_namcust': '',
      'phone': '',
      'flg_inout': '',
      'filenamei': '',
      'filenameo': ''
    },
    custNewLatLngSelected: [],
    pathImage: '',
    flgLoading: false
  },
  getters: {
    [types.GET_CHECKIN_PLACE_DISP] (state) {
      return state.placeDisp
    },
    [types.GET_CHECKIN_HISTORY_DISP] (state) {
      return state.historyDisp
    },
    [types.GET_CHECKIN_HIS_DETAIL_DISP] (state) {
      return state.hisDetailDisp
    },
    [types.GET_CHECKIN_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_CHECKIN_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_CHECKIN_LABELS] (state) {
      return state.labels
    },
    [types.GET_CHECKIN_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_CHECKIN_PLACE] (state) {
      return state.place
    },
    [types.GET_CHECKIN_PLACE_NEW_LATLNG] (state) {
      return state.placeNewLatLng
    },
    [types.GET_CHECKIN_HISTORY] (state) {
      return state.history
    },
    [types.GET_CHECKIN_RADIUS] (state) {
      return state.radius
    },
    [types.GET_CHECKIN_DETAIL_SELECTED] (state) {
      return state.detailSelected
    },
    [types.GET_CHECKIN_DATA_IN_RADIUS] (state) {
      return state.dataInRadius
    },
    [types.GET_CHECKIN_HIS_SELECTED] (state) {
      return state.historySelected
    },
    [types.GET_LAST_CHECKIN] (state) {
      return state.lastCheckIn
    },
    [types.GET_CHECKIN_NEW_LAT_LNG_SELECTED] (state) {
      return state.custNewLatLngSelected
    },
    [types.GET_CHECKIN_PATH_IMAGE] (state) {
      return state.pathImage
    },
    [types.GET_FLG_LOADING] (state) {
      return state.flgLoading
    }
  },
  mutations: {
    [types.SET_CHECKIN_PLACE_DISP] (state, placeDisp) {
      state.placeDisp = placeDisp
    },
    [types.SET_CHECKIN_HISTORY_DISP] (state, historyDisp) {
      state.historyDisp = historyDisp
    },
    [types.SET_CHECKIN_HIS_DETAIL_DISP] (state, hisDetailDisp) {
      state.hisDetailDisp = hisDetailDisp
    },
    [types.SET_CHECKIN_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_CHECKIN_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_CHECKIN_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].custNewLatLng = configLabel.replaceLabelToColumns(state.columns[keyLang].custNewLatLng, labels[keyLang])
      }
    },
    [types.SET_CHECKIN_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_CHECKIN_PLACE] (state, place) {
      state.placeAll = place
      state.place = place
    },
    [types.SET_CHECKIN_PLACE_NEW_LATLNG] (state, data) {
      let objPlace = {
        rows: data,
        total: data.length
      }
      state.placeNewLatLng = objPlace
    },
    [types.SET_CHECKIN_RADIUS] (state, radius) {
      state.radius = radius
    },
    [types.SET_CHECKIN_HISTORY] (state, history) {
      state.history = history
    },
    [types.SET_CHECKIN_DETAIL_SELECTED] (state, detailSelected) {
      state.detailSelected = detailSelected
    },
    [types.SET_CHECKIN_DATA_IN_RADIUS] (state, data) {
      state.dataInRadius = data
    },
    [types.SET_CHECKIN_HIS_SELECTED] (state, data) {
      state.historySelected = data
    },
    [types.SET_LAST_CHECKIN] (state, data) {
      state.lastCheckIn = data
      /* if (state.lastCheckIn.dteout) {  // for demo
        state.lastCheckIn.dteout = ''
        state.lastCheckIn.flg_inout = 'I'
        state.lastCheckIn.codcust = data.codcust
        state.lastCheckIn.codreason = data.codreason
        state.lastCheckIn.activity = data.activity
        state.lastCheckIn.new_namcust = data.new_namcust
        state.lastCheckIn.phone = data.phone
      } else {
        state.lastCheckIn.dteout = moment().format('DD/MM/YYYY')
        state.lastCheckIn.flg_inout = 'O'
      } */  // for demo
    },
    [types.SET_CHECKIN_NEW_LAT_LNG_SELECTED] (state, data) {
      state.custNewLatLngSelected = data
    },
    [types.SET_CHECKIN_PATH_IMAGE] (state, pathImage) {
      state.pathImage = pathImage
    },
    [types.SET_FLG_LOADING] (state, flgLoading) {
      state.flgLoading = flgLoading
    }
  },
  actions: {
    [types.TOGGLE_CHECKIN_PAGE] ({ commit }, page) {
      let placeDisp = false
      let historyDisp = false
      let hisDetailDisp = false
      let detailDisp = false
      switch (page) {
        case 'place':
          placeDisp = true
          break
        case 'history':
          historyDisp = true
          break
        case 'hisDetail':
          hisDetailDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_CHECKIN_PLACE_DISP, placeDisp)
      commit(types.SET_CHECKIN_HISTORY_DISP, historyDisp)
      commit(types.SET_CHECKIN_HIS_DETAIL_DISP, hisDetailDisp)
      commit(types.SET_CHECKIN_DETAIL_DISP, detailDisp)
    },
    [types.STOP_FLG_LOADING] ({ commit }) {
      commit(types.SET_FLG_LOADING, false)
    },
    [types.START_FLG_LOADING] ({ commit }) {
      commit(types.SET_FLG_LOADING, true)
    },
    [types.RECEIVED_CHECKIN_COLUMNS_LABELS] ({ commit }) {
      checkin.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_CHECKIN_COLUMNS, data.labels)
          commit(types.SET_CHECKIN_LABELS, data.labels)
        })
        .catch((response) => {
          const data = response.response.data
          swal({title: '', text: data.response, html: true, type: 'error'})
        })
    },
    [types.RECEIVED_CHECKIN_DROPDOWNS] ({ state, commit }) {
      checkin.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_CHECKIN_DROPDOWNS, data)
        })
        .catch((error) => {
          console.log(error)
          checkin.getDropdowns()
          .then((response2) => {
            const data2 = JSON.parse(response2.request.response)
            commit(types.SET_CHECKIN_DROPDOWNS, data2)
          })
          .catch((error2) => {
            const data2 = error2.response.data
            swal({title: '', text: data2.response, html: true, type: 'error'})
          })
        })
    },
    [types.RECEIVED_CHECKIN_PLACE] ({ commit }, searchParams) {
      commit(types.SET_FLG_LOADING, true)
      checkin.getCust(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_CHECKIN_PLACE, data)
          commit(types.SET_CHECKIN_PLACE_NEW_LATLNG, [])
          if (data.length <= 0) {
            swal({title: '', text: constLabels('msgNoLocation'), html: true, type: 'error'})
          } else {
            swal.close()
          }
          commit(types.SET_FLG_LOADING, false)
        })
        .catch((error) => {
          const data = error.response.data
          commit(types.SET_CHECKIN_PLACE, [])
          commit(types.SET_CHECKIN_PLACE_NEW_LATLNG, [])
          swal({title: '', text: data.response, html: true, type: 'error'})
          commit(types.SET_FLG_LOADING, false)
        })
    },
    [types.RECEIVED_CHECKIN_PLACE_NO_LOCATION] ({ commit }, searchParams) {
      checkin.getCustNoLocation(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_CHECKIN_PLACE_NEW_LATLNG, data)
          swal.close()
        })
        .catch((error) => {
          const data = error.response.data
          commit(types.SET_CHECKIN_PLACE_NEW_LATLNG, [])
          swal({title: '', text: data.response, html: true, type: 'error'})
        })
    },
    [types.RECEIVED_CHECKIN_DATA_IN_RADIUS] ({ commit }, searchParams) {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      checkin.getCust(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_CHECKIN_DATA_IN_RADIUS, data)
          let chkFoundLatLng = data.filter(function (dataFilter) {
            return dataFilter.position.lat !== 0
          })
          if (chkFoundLatLng.length <= 0) {
            swal({title: '', text: constLabels('msgNoLocation'), html: true, type: 'error'})
          } else {
            swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false, timer: 0})
          }
        })
        .catch((error) => {
          const data = error.response.data
          swal({title: '', text: data.response, html: true, type: 'error'})
        })
    },
    [types.RECEIVED_CHECKIN_HISTORY] ({ commit }, searchParams) {
      checkin.getHistory(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_CHECKIN_HISTORY, data)
        })
        .catch((response) => {
          const data = response.response.data
          swal({title: '', text: data.response, html: true, type: 'error'})
        })
    },
    [types.RECEIVED_LAST_CHECKIN] ({ commit }, searchParams) {
      checkin.getLastCheckIn(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_LAST_CHECKIN, data)
          // commit(types.SET_LAST_CHECKIN, searchParams) // for demo
        })
        .catch((response) => {
          const data2 = response.response.data
          console.warn('Try recieve last_checkin again', data2.response)
          checkin.getLastCheckIn(searchParams)
            .then((response) => {
              const data2 = JSON.parse(response.request.response)
              commit(types.SET_LAST_CHECKIN, data2)
              // commit(types.SET_LAST_CHECKIN, searchParams) // for demo
            })
            .catch((response) => {
              const data2 = response.response.data
              swal({title: '', text: data2.response, html: true, type: 'error'})
            })
        })
    },
    [types.SAVE_CHECKIN] ({ commit, dispatch }, {saveParams, searchParams}) {
      let codempid = searchParams.codempid
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          checkin.saveCheckIn(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              commit(types.SET_CHECKIN_NEW_LAT_LNG_SELECTED, [])
              dispatch(types.RECEIVED_CHECKIN_HISTORY, codempid)
              dispatch(types.RECEIVED_LAST_CHECKIN, codempid)
              // dispatch(types.RECEIVED_LAST_CHECKIN, saveParams) // for demo
              dispatch(types.TOGGLE_CHECKIN_PAGE, 'place')
              swal({title: '', text: data.response, html: true, type: 'success'})
            })
            .catch((response) => {
              const data = response.response.data
              swal({title: '', text: data.response, html: true, type: 'error'})
            })
        }
      })
    },
    [types.SAVE_CHECKIN_DETAIL] ({ commit, dispatch, state }, {saveParams, searchParams}) {
      let codempid = searchParams
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          checkin.saveCheckInDetail(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_CHECKIN_HISTORY, codempid)
              dispatch(types.RECEIVED_LAST_CHECKIN, codempid)
              state.historySelected = saveParams
              swal({title: '', text: data.response, html: true, type: 'success'})
            })
            .catch((response) => {
              const data = response.response.data
              swal({title: '', text: data.response, html: true, type: 'error'})
            })
        }
      })
    },
    [types.SAVE_CHECKIN_LOG] ({ commit, dispatch, state }, {params}) {
      checkin.log(params)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6oe/index.js